import React, { useEffect, useState, useRef, useCallback, useContext } from 'react';
import ItemMaster from '../../../API/APIServices/ItemMaster';
import ItemGroup from '../../../API/APIServices/ItemGroup';
import ConfirmDeletionWithUserInput from '../../Props/ConfirmDeletionWithUserInput';
import CustomizeDeleteService from '../../../API/APIServices/CustomizeDeleteService';
import MyContext from '../../MyContext';
import Account from '../../../API/APIServices/Account';




function ItemCustomizeDelete({ setLoading }) {

    const [productListData, setProductListData] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [page, setPage] = useState(1);
    const [pageGroup, setPageGroup] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalRecordsGroup, setTotalRecordsGroup] = useState(0);
    const [productGroupData, setProductGroupData] = useState([]);
    const [isItemGroupShow, setIsItemGroupShow] = useState(false);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [isSoftDelete, setIsSoftDelete] = useState(true);
    const [isDeleteAttributeItemChild, setIsDeleteAttributeItemChild] = useState(true);
    const [isDropdownProductName, setIsDropdownProductName] = useState(false);
    const [isDropdownProductGroupName, setIsDropdownProductGroupName] = useState(false);
    const [productSuggestion, setProductSuggestion] = useState([]);
    const [productGroupSuggestion, setProductGroupSuggestion] = useState([]);
    const [productName, setProductName] = useState("");
    const [productGroupName, setProductGroupName] = useState("");
    const [selectedProductName, setSelectedProductName] = useState("");
    const [selectedProductGroupName, setSelectedProductGroupName] = useState("");
    const [productId, setProductId] = useState(0);
    const [productGroupId, setProductGroupId] = useState(0);



    const dropDownRef = useRef(null);
    const { debounce } = useContext(MyContext);


    async function fetchProductList(page_num, product_id, product_group_id) {


        setLoading(true);
        try {


            let filterToSend = [];

            if (product_id) {

                filterToSend.push({
                    "fieldName": "d2Id",
                    "operatorName": "equal",
                    "compareValue": product_id
                });

            }

            if (product_group_id) {

                filterToSend.push({
                    "fieldName": "parentGrpId2",
                    "operatorName": "equal",
                    "compareValue": product_group_id
                });

            }

            const filter = {
                "filter": filterToSend,
                "order": [
                    {
                        "propertyName": "string",
                        "ascending": true
                    }
                ],
                "attribute": [
                    {
                        "parentId": 0,
                        "attrId": 0
                    }
                ],
                "ecomAttributeFilter": true,
                "pageNumber": page_num,
                "pageSize": pageSize,
                "itemGroupId2": 0,
                "isEcom": true
            };

            const data = await ItemMaster.GetItemMasterWithPagination(filter);

            if (data) {

                if (data.isSuccess) {

                    const list = data.result.map(item => {

                        item.isSelected = false;
                        return item;
                    });

                    setProductListData(list);
                    setTotalRecords(data.totalRecords);
                } else {
                    console.log("Error in fetching product group", data.errorMessages);
                }
            }

        } catch (error) {
            console.log("Error in fetching product group", error);
        }

        setLoading(false);
    }

    async function fetchProductGroup(page_num) {

        try {

            const data = {
                "filter": [
                    {
                        "fieldName": "string",
                        "operatorName": "string",
                        "compareValue": "string"
                    }
                ],
                "order": [
                    {
                        "propertyName": "string",
                        "ascending": true
                    }
                ],
                "pageNumber": page_num,
                "pageSize": pageSize
            };

            const response = await ItemGroup.getItemGroupMasters(data);

            if (response.data.isSuccess) {

                const list = response.data.result.map(item => {

                    item.isSelected = false;
                    return item;
                });

                setProductGroupData(list);
                setTotalRecordsGroup(response.data.totalRecords);
            } else {
                console.log("Error in fetching product group", response.data.errorMessages);
            }
        } catch (error) {
            console.log("Error in fetching product group", error);
        }
    }

    useEffect(() => {
        fetchProductList(page, productId, productGroupId);
    }, [page, productId, productGroupId]);

    useEffect(() => {
        // fetchProductGroup(pageGroup);
    }, [pageGroup]);

    function handlePrevClick() {

        if (page <= 1) return;

        setPage(page - 1);
    }

    function handleNextClick() {

        if (page >= Math.ceil(totalRecords / pageSize)) return;

        setPage(page + 1);
    }

    function handlePrevClickGroup() {

        if (pageGroup <= 1) return;

        setPageGroup(pageGroup - 1);
    }

    function handleNextClickGroup() {

        if (pageGroup >= Math.ceil(totalRecordsGroup / pageSize)) return;

        setPageGroup(pageGroup + 1);
    }

    function toggleItemGroupShow() {

        setIsItemGroupShow(!isItemGroupShow);
    }

    async function handleDelete() {

        setConfirmDeleteOpen(false);
        setLoading(true);

        try {

            const items_D2Id = productListData.filter(item => item.isSelected).map(item => item.d2Id);
            // const itemGroups_D2Id = productGroupData.filter(item => item.isSelected).map(item => item.d2_Id);


            const data = {
                "itemGroups_D2Id": [productGroupId],
                "items_D2Id": items_D2Id,
                "deleteAttributeItemChild": isDeleteAttributeItemChild,
                "softDelete": isSoftDelete
            }

            console.log("data", data);

            const response = await CustomizeDeleteService.DeleteItemsAsync(data);

            if (response.data.isSuccess) {

                // fetchProductGroup(pageGroup);
                fetchProductList(page, productId, productGroupId);
                alert("item Deleted Successfully!");
            } else {
                console.log("Error in Item Custom Delete", response?.data?.errorMessages);
                alert("Failed to delete!")
            }

        } catch (e) {
            console.log("Error in Item Custom Delete", e?.response?.data?.errorMessages);
            alert("Failed to delete!")
        }

        setLoading(false);
    }

    function handleItemGroupSelect(e, index) {

        const bool = e.target.checked;
        const tempProductGroupData = [...productGroupData];

        tempProductGroupData[index].isSelected = bool;
        setProductGroupData(tempProductGroupData);
    }


    function handleItemSelect(e, index) {

        const bool = e.target.checked;
        const tempProductListData = [...productListData];

        tempProductListData[index].isSelected = bool;
        setProductListData(tempProductListData);
    }


    const fetchSuggestions = async (name, value, GroupId, MasterType) => {

        const filteredData = {
            MasterType: MasterType,
            GroupWiseSuggestion: true,
            GroupId: GroupId,
            search_str: value,
            PageNumber: 1,
            PageSize: 50,
        };

        try {
            const SearchItem = await Account.GetAccountListForAutoSuggestion(
                filteredData
            );

            if (SearchItem) {
                return SearchItem;
            } else {
                return [];
            }
        } catch (error) {
            console.error("Error fetching item suggestions:", error);
            return [];
        }
    };

    const debouncedFetchProductSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 4);

            setProductSuggestion(SearchItem);
            setIsDropdownProductName(true);

        }, 500),
        []
    );

    const debouncedFetchProductGroupSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 3);

            setProductGroupSuggestion(SearchItem);
            setIsDropdownProductGroupName(true);

        }, 500),
        []
    );

    const handleProductNameChange = (e) => {

        setProductName(e.target.value);
        setSelectedProductName("");
        setProductId(0);
        debouncedFetchProductSuggestions("ProductName", e.target.value, '');
    }

    const handleProductNameSelection = async (id, name) => {

        console.log(id, name)
        setProductName(name);
        setProductId(id);
        setSelectedProductName(name);
        setIsDropdownProductName(false);
    };

    const handleProductGroupNameChange = (e) => {

        setProductGroupName(e.target.value);
        setSelectedProductGroupName("");
        setProductGroupId(0);
        debouncedFetchProductGroupSuggestions("ProductGroupName", e.target.value, '');
    }

    const handleProductGroupNameSelection = async (id, name) => {

        console.log(id, name)
        setProductGroupName(name);
        setProductGroupId(id);
        setSelectedProductGroupName(name);
        setIsDropdownProductGroupName(false);
    };

    useEffect(() => {

        function handleClickOutside(event) {

            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsDropdownProductGroupName(false)
                setIsDropdownProductName(false);
            }
        }


        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);



    return (
        <div className="padding-20">

            <div className="company_info-text-im relative" style={{ height: "60px", zIndex: 5 }}>

                <div className='customize-delete-button customize-delete-heading-select' style={{ left: "10px" }}>

                    <div >Item Deletion</div>

                </div>

                <button onClick={() => setConfirmDeleteOpen(!confirmDeleteOpen)} className="product-price-account-wise-delete-button customize-delete-button">Delete</button>

            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "15px" }}>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isSoftDelete}
                    onChange={((e) => setIsSoftDelete(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Soft Delete</span>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isDeleteAttributeItemChild}
                    onChange={((e) => setIsDeleteAttributeItemChild(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Delete Attribute Item Child</span>
            </div>

            <div className="search_panel_hd1">
                <div style={{ width: "60%" }}>
                    <div ref={dropDownRef} className="col-sm-n1" style={{ width: "100%", alignItems: "center", justifyContent: "center" }}>

                        <div className="group_head" style={{ position: "relative" }}>
                            <input style={{ width: "90%" }} value={productName} onChange={handleProductNameChange} onClick={() => {

                                setIsDropdownProductGroupName(false);
                                debouncedFetchProductSuggestions("ProductName", productName, '')
                            }
                            } placeholder="Product Name" type="text" className="bill_panel_input" />


                            {isDropdownProductName && (
                                <ul
                                    style={{ position: "absolute", top: "35px" }}
                                    className="ItemmasterDuggestionsaleinvoice"

                                >
                                    {productSuggestion.map((pName, index) => (
                                        <li
                                            key={index}

                                            onClick={() =>
                                                handleProductNameSelection(
                                                    pName.id,
                                                    pName.name
                                                )
                                            }
                                        >
                                            {pName.name}
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </div>

                        <div className="group_head" style={{ position: "relative" }}>
                            <input style={{ width: "90%" }} value={productGroupName} onChange={handleProductGroupNameChange} onClick={() => {

                                setIsDropdownProductName(false);
                                debouncedFetchProductGroupSuggestions("ProductGroupName", productGroupName, '')
                            }
                            } placeholder="Product Group Name" type="text" className="bill_panel_input" />


                            {isDropdownProductGroupName && (
                                <ul
                                    style={{ position: "absolute", top: "35px" }}
                                    className="ItemmasterDuggestionsaleinvoice"

                                >
                                    {productGroupSuggestion.map((pgName, index) => (
                                        <li
                                            key={index}

                                            onClick={() =>
                                                handleProductGroupNameSelection(
                                                    pgName.id,
                                                    pgName.name
                                                )
                                            }
                                        >
                                            {pgName.name}
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </div>

                    </div>
                </div>


            </div>

            <div className='customize-delete-table-overflow'>
                <table className="lens-stock-table">

                    <thead>
                        <tr>

                            <th style={{ width: "50px" }} className="lens-stock-table-th">S.No.</th>
                            <th style={{ width: "50px" }} className="lens-stock-table-th">Select</th>
                            <th className="lens-stock-table-th">Item Id</th>
                            <th className="lens-stock-table-th">Item Name</th>
                            <th className="lens-stock-table-th">Item Group</th>

                        </tr>
                    </thead>

                    <tbody>

                        {productListData.map((item, index) => {

                            if (index % 2 === 0) {

                                return (
                                    <tr key={index} className="TrLensCreation" style={item.isSelected ? {backgroundColor:"#beddfc"} : {}}>

                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{index + 1}</td>

                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                            <input checked={item.isSelected} onChange={(e) => handleItemSelect(e, index)} type="checkbox" />
                                        </td>
                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2Id}</td>
                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name}</td>
                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.parentGrpName}</td>
                                    </tr>
                                );
                            } else {

                                return (
                                    <tr key={index} className="TrLensCreation customize-delete-alternate-color" style={item.isSelected ? {backgroundColor:"#beddfc"} : {}}>

                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{index + 1}</td>

                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                            <input checked={item.isSelected} onChange={(e) => handleItemSelect(e, index)} type="checkbox" />
                                        </td>
                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2Id}</td>
                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name}</td>
                                        <td style={{backgroundColor:"inherit"}} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.parentGrpName}</td>
                                    </tr>
                                );
                            }

                        })}

                    </tbody>
                </table>
            </div>

            <div style={{ backgroundColor: "#E1EFFD", justifyContent: "end", marginTop: "5px", padding: "10px 0px", borderRadius: "4px" }} className="flex">

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "25%" }}>
                    <button disabled={page <= 1 ? true : false} onClick={handlePrevClick} class="table-list-button">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <span class="table-list-page-txt">Page - <strong style={{ margin: "0px 3px;" }}>{page} of {Math.ceil(totalRecords / pageSize)}</strong></span>
                    <button disabled={page >= Math.ceil(totalRecords / pageSize) ? true : false} onClick={handleNextClick} class="table-list-button">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>

            {/* <div style={{ marginTop: "10px" }} className='company_info-text-im'>

                Item Group Wise Deletion
            </div>

            <div className='customize-delete-table-overflow'>
                <table className="lens-stock-table">

                    <thead>
                        <tr>

                            <th style={{ width: "50px" }} className="lens-stock-table-th">S.No.</th>
                            <th style={{ width: "50px" }} className="lens-stock-table-th">Select</th>
                            <th className="lens-stock-table-th">Item Group Id</th>
                            <th className="lens-stock-table-th">Item Group Name</th>

                        </tr>
                    </thead>

                    <tbody>

                        {productGroupData.map((item, index) => (

                            <tr key={index} className="TrLensCreation">

                                <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{index + 1}</td>

                                <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                    <input checked={item.isSelected} onChange={(e) => handleItemGroupSelect(e, index)} type="checkbox" />
                                </td>
                                <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2_Id}</td>
                                <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name || ""}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>
            </div>

            <div style={{ backgroundColor: "#E1EFFD", justifyContent: "end", marginTop: "5px", padding: "10px 0px", borderRadius: "4px" }} className="flex">

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "25%" }}>
                    <button disabled={pageGroup <= 1 ? true : false} onClick={handlePrevClickGroup} class="table-list-button">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <span class="table-list-page-txt">Page - <strong style={{ margin: "0px 3px;" }}>{pageGroup} of {Math.ceil(totalRecordsGroup / pageSize)}</strong></span>
                    <button disabled={pageGroup >= Math.ceil(totalRecordsGroup / pageSize) ? true : false} onClick={handleNextClickGroup} class="table-list-button">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div> */}


            {confirmDeleteOpen && <ConfirmDeletionWithUserInput
                HeadingTop="Are you sure you want to delete!"
                closeButtonClick={() => { setConfirmDeleteOpen(false) }}
                onYesClick={handleDelete}
            />}

        </div>
    );
}

export default ItemCustomizeDelete;